import { useState, useEffect } from 'react';
import useStores from '$src/hooks/useStores';
import useFeature from '$src/hooks/useFeature';

const onboarding30FeatureFlagName = 'stark-feature-next-onboarding-3-0';

export function useOnboarding30Status() {
  // Adding extra fetchStatus to clarify the loading state, as [isFeatureActiveRaw, isFFLoading] are insufficient.
  /**
   * @typedef {"PENDING" | "LOADING" | "DONE" | "FAILED"} FetchStatus
   */
  /**
   * @type {[FetchStatus]}
   */
  const [fetchStatus, setFetchStatus] = useState('PENDING');
  const {
    sessionStore: { fetchMe },
  } = useStores();
  const [isFeatureActiveRaw, isLoadingRaw] = useFeature(onboarding30FeatureFlagName);
  if (fetchStatus === 'PENDING' && isLoadingRaw) {
    setFetchStatus('LOADING');
  }
  if (fetchStatus === 'LOADING' && !isLoadingRaw) {
    setFetchStatus('DONE');
  }
  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  return {
    isLoading: fetchStatus === 'PENDING' || fetchStatus === 'LOADING',
    isFeatureActive: fetchStatus === 'DONE' && isFeatureActiveRaw,
  };
}

